// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"1492":"2cd545e1","3141":"93caecf1","3516":"2cd545e1","4602":"afed0203","4985":"349b3714","5627":"b4645b29","5945":"2cd545e1"}[chunkId] + ".css";
};